import { usePageInfo } from 'app/hooks/usePageInfo';
import { observer } from 'mobx-react-lite';
import { MobxContext } from 'shared/lib/contexts/mobxContext';
import React, { useContext, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

const publicPaths = ['/login', '/signup', '/password_recover'];

export default observer(function RedirectWrapper({
  children,
}: {
  children: React.ReactNode;
}) {
  const {
    mobxStore: { authStore },
  } = useContext(MobxContext);
  const navigate = useNavigate();

  const { isAuth, user } = authStore;
  const { isAdminPage, isTrashPage } = usePageInfo();
  const pathname = useLocation().pathname;

  const isAdmin = user ? user.isAdmin : true;

  useEffect(() => {
    if (!isAuth && !publicPaths.includes(pathname)) {
      navigate('/login', { replace: true });
    }

    if (!isAdmin && (isAdminPage || isTrashPage)) {
      navigate('/', { replace: true });
    }

    if (isAuth && publicPaths.includes(pathname)) {
      navigate('/', { replace: true });
    }
  }, [navigate, isAuth, pathname, isAdmin, isAdminPage, isTrashPage]);

  return <>{children}</>;
});
